




















































import { mixins } from 'vue-class-component'
import { Component, Prop } from 'vue-property-decorator'
import AppTextarea from '@/components/AppTextarea.vue'
import AppTextField from '@/components/AppTextField.vue'
import AppTextSearch from '@/components/AppTextSearch.vue'
import AppSelector from '@/components/AppSelector.vue'
import AppFormCheckbox from '@/components/AppFormCheckbox.vue'
import { IVehicleInfoInput } from '@/modules/Vehicle/interfaces/vehicle-form'
import SearchPolicy from '@/mixins/search-queries/search-policy'
import { vehicleCoverageValues } from '@/modules/Vehicle/helpers/vehicle'
import { vehicleOwnerships } from '@/modules/Vehicle/helpers/vehicle-ownership'
import { vehicleUseages } from '@/modules/Vehicle/helpers/vehicle-useage'

@Component({
  components: {
    AppTextField,
    AppSelector,
    AppTextarea,
    AppTextSearch,
    AppFormCheckbox
  }
})
export default class VehicleFormInfo extends mixins(SearchPolicy) {
  @Prop({ type: Object as () => IVehicleInfoInput }) value!: IVehicleInfoInput

  vehicleCoverageValues = vehicleCoverageValues
  vehicleOwnerships = vehicleOwnerships
  vehicleUseages = vehicleUseages

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
